export default __webpack_public_path__ + "static/media/Landing.3bf3cb24.jpg";